import { render, staticRenderFns } from "./valueUp.vue?vue&type=template&id=33e82e36&"
import script from "./valueUp.vue?vue&type=script&lang=ts&"
export * from "./valueUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports